import Markdown from 'markdown-to-jsx'
import React from 'react'

import { PageBlockCommonHeadlineSize } from '@/legacy-src/components/pageBlocks/types'
import { ButtonLink } from '@/legacy-src/components/ui/button'
import { cn } from '@/legacy-src/lib/utils'

const Heading: React.FC<{
  text: string
  headlineSize?: PageBlockCommonHeadlineSize
}> = ({ text, headlineSize }) => (
  <h2
    className={cn(
      'mb-0 text-balance leading-9',
      headlineSize === PageBlockCommonHeadlineSize.larger ? 'text-4xl font-normal tablet:text-5xl' : 'text-3xl',
    )}
  >
    {text}
  </h2>
)

const Text = ({ children, className = '' }) => (
  <div className={cn('mt-3 text-lg', className)}>
    {typeof children === 'string' ? <Markdown>{children}</Markdown> : children}
  </div>
)

type Props = {
  headlineText?: string
  text?: React.ReactNode
  image?: React.ReactNode
  buttonText?: string
  buttonLink?: string
  align?: 'left' | 'center' | 'right'
  className?: string
  headlineSize?: PageBlockCommonHeadlineSize
  badge?: { text: string; className?: string }
}

const ContentHeader: React.FC<Props> = ({
  className = '',
  headlineText,
  headlineSize = PageBlockCommonHeadlineSize.default,
  text,
  buttonLink,
  buttonText,
  image,
  badge,
  align = 'center',
}) => {
  return (
    <div
      className={cn(
        'mb-6 flex flex-col',
        align === 'left' ? 'items-start' : align === 'right' ? 'items-end' : 'items-center text-center',
        className,
      )}
    >
      {image ?? null}
      {badge && (
        <div
          className={cn(
            'mb-4 rounded-lg bg-secondary px-2 py-1 text-base font-semibold leading-[22px] text-white',
            badge.className,
          )}
        >
          {badge.text}
        </div>
      )}

      <div className="">
        {headlineText ? <Heading text={headlineText} headlineSize={headlineSize} /> : null}
        {text && <Text className="mb-0">{text}</Text>}
      </div>

      {buttonText && buttonLink && (
        <ButtonLink href={buttonLink} size="default">
          {buttonText}
        </ButtonLink>
      )}
    </div>
  )
}

export { ContentHeader, Text, Heading }
